// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import BootstrapVue from 'bootstrap-vue';

import router from './router';
import firebase from 'firebase';
import 'firebase/firestore';
import './assets/css/app.scss';

import { store, } from './store/index.js';
// eslint-disable-next-line no-undef
const fb = require('./services/firebaseConfig.js');

Vue.config.productionTip = false;

Vue.use(BootstrapVue);

router.beforeEach((to, from, next) => {
	const requiresAuth = to.matched.some((x) => x.meta.requiresAuth);
	const currentUser = firebase.auth().currentUser;

	if (requiresAuth && !currentUser) {
		next('/login');
	} else if (requiresAuth && currentUser) {
		next();
	} else {
		next();
	}
});

let app;
fb.auth.onAuthStateChanged(() => {
	if (!app) {
		app = new Vue({
			el: '#app',
			router,
			store,
			components: { App, },
			render: (h) => h(App),
		});
	}
});



// WEBPACK FOOTER //
// ./src/main.js